import { Component, OnInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Claim } from '../../../services/colmec-claim.service';

@Component({
    selector: 'colmec-claim-grid-view',
    templateUrl: './colmec-claim-grid-view.component.html',
    styleUrls: ['./colmec-claim-grid-view.component.scss'],
    standalone: false
})
export class ColmecClaimGridViewComponent extends ListItemRendererComponent<Claim[]> implements OnInit {

  ngOnInit(): void {}
}
